var expObj = {};
export default expObj;

/**
 * 打散时间数组 如预送达时间和自取时间的下拉
 * @param [*] dates , appointTimes 或 takeSelfTimes
 * @param Number type , 类型1返回用于 optgroup, 类型2返回时间组合 
 * @return []
 */
var formatDates_block = (h1,m1,h2,m2)=>{
	var timerEX = 15;
	var _m1=m1,_h1=h1;
	if(m1<(60-timerEX)){
		_m1 += timerEX;
	}else{
		_m1 += timerEX-60;
		_h1++;
	}
	if(h1<10){h1="0"+h1}
	if(m1<10){m1="0"+m1}
	if((_h1*60+_m1) <= (h2*60+m2)){
		return [h1+":"+m1].concat(formatDates_block(_h1,_m1,h2,m2));
	}else{
		return h1+':'+m1;
	}
}
expObj.formatDates = function(dates = [],type = 1){
	
	dates = dates.filter(date => date.times&&date.times.length); //容错
	
	var _dates = [];
	dates.forEach(date=>{
		var _times = [];
		date.times.forEach(time=>{
			var [temp1,temp2] = time.split("~");
			if(!(temp1 && temp2)){return ;}
			var [temp1_1,temp1_2] = temp1.split(":");
			var [temp2_1,temp2_2] = temp2.split(":");
			temp1_1 = parseInt(temp1_1);
			temp1_2 = parseInt(temp1_2);
			temp2_1 = parseInt(temp2_1);
			temp2_2 = parseInt(temp2_2);
			
			_times = _times.concat(formatDates_block(temp1_1,temp1_2,temp2_1,temp2_2));
			
		});
		
		if(type == 1){ // for optgroup
			_dates.push({
				day:date.date,
				times:_times
			})
		}else if(type ==2){ //only for option
			_times = _times.map(time=>{
				return date.date+' '+time;
			})
			_dates = _dates.concat(_times);
		}
	});

	return _dates;
	
}
export const formatDates = expObj.formatDates ;


// WEBPACK FOOTER //
// ./../../plugins/utils/store.js